module.exports = __webpack_public_path__ + "img/adjust-icon.7689cba4.svg";